var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHanfeng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 680",
    d: "M6.68762 1H3.12109C2.84495 1 2.62109 1.22386 2.62109 1.5V8.19313C2.62109 9.2977 3.51652 10.1931 4.62109 10.1931H9.93225C10.2084 10.1931 10.4323 10.417 10.4323 10.6931V14.5C10.4323 14.7761 10.6561 15 10.9323 15H14.2584C14.5346 15 14.7584 14.7761 14.7584 14.5V7.77682C14.7584 6.67225 13.863 5.77682 12.7584 5.77682H7.68762C7.41147 5.77682 7.18762 5.55297 7.18762 5.27682V1.5C7.18762 1.22386 6.96376 1 6.68762 1Z",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 60",
    x1: 2.44092,
    y1: 2.72318,
    x2: 7.1877,
    y2: 2.72318,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 61",
    x1: 10.312,
    y1: 12.9378,
    x2: 15.0588,
    y2: 12.9378,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 62",
    x1: 8.73926,
    y1: 5.62662,
    x2: 8.73926,
    y2: 10.3734,
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHanfeng);
export default __webpack_public_path__ + "static/media/hanfeng.0ba4695d66921d9b38babb34168f5d66.svg";
export { ForwardRef as ReactComponent };